import { AccessCodeInput } from "./access-code-input.js";
import { Box, Container, Paper, Typography, useTheme } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { SupportContext } from "./provider.js";
import { useTranslation } from "next-i18next";
import { ChevronRight } from "@mui/icons-material";
import React from "react";
export const EnterAccessCode = ({ body, headline }) => {
    const { t } = useTranslation("c-support");
    const theme = useTheme();
    const { accessCode: storedAccessCode, error, isLoading, submitAccessCode, } = React.useContext(SupportContext);
    const [accessCode, setAccessCode] = React.useState(storedAccessCode);
    const handleCodeChange = (value) => setAccessCode(value);
    const handleSubmit = () => submitAccessCode(accessCode, "manual");
    return (React.createElement(Container, { maxWidth: "md" },
        React.createElement(Typography, { sx: { pb: 6 }, variant: "h1" }, headline ?? t("enter-code-headline-1", "Dein Zugangscode")),
        body ?? (React.createElement(Typography, { sx: { maxWidth: "md" }, paragraph: true, variant: "body1" }, t("enter-code-copy-1", "Mit dem Zugangscode, der deinem Culinario Mortale Krimidinner beiliegt, kannst du dir die Rollenbeschreibungen sowie für Notfälle bis zu zwei komplette Broschüren herunterladen."))),
        !!error && (React.createElement(Paper, { sx: {
                backgroundColor: theme.palette.error.main,
                border: `1px solid ${theme.palette.error.dark}`,
                color: "white",
                px: 2,
                py: 1.5,
            } },
            React.createElement(Typography, { sx: { maxWidth: "md" }, variant: "body1" }, error.message))),
        React.createElement(Box, { sx: { my: 3 } },
            React.createElement(AccessCodeInput, { "data-testid": "access-code-input", onChange: handleCodeChange, value: accessCode })),
        React.createElement(LoadingButton, { color: "primary", "data-testid": "submit-access-code-btn", endIcon: React.createElement(ChevronRight, null), loading: isLoading, loadingPosition: "end", onClick: handleSubmit, sx: { width: { xs: "100%", sm: "auto" } }, variant: "contained" },
            React.createElement(Box, { sx: { pl: 1 } }, t("enter-code-submit-button", "Anmelden")))));
};
//# sourceMappingURL=enter-access-code.js.map